import React from 'react'

const REQUIRED_FIELD_SYMBOL = '*'

interface Props {
  title?: string
  id?: string
  required?: boolean
}

export const Title: React.FC<Props> = ({ title, id, required }) => {
  if (!title) {
    return null
  }

  return (
    <legend id={id}>
      {title}
      {required && <span className="required">{REQUIRED_FIELD_SYMBOL}</span>}
    </legend>
  )
}
